var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#222222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2516_4956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2967 8C17.2417 8 17.1868 8 17.1209 8C17.0879 8 17.0659 8 17.033 8H12.6703C12.5714 8 12.4835 8.01075 12.3956 8.03224C11.8681 8.15044 11.4725 8.62326 11.4725 9.1713V9.25727C11.4725 9.7086 11.7363 10.1062 12.1209 10.2996C12.2857 10.3856 12.4725 10.4286 12.6703 10.4286H17.3077C17.967 10.4286 18.5055 10.9551 18.5055 11.5999V11.6858C18.5055 12.3306 17.967 12.8571 17.3077 12.8571H6.1978C5.53846 12.8571 5 13.3837 5 14.0284V14.1144C5 14.7592 5.53846 15.2857 6.1978 15.2857H12.2418C12.9011 15.2857 13.4396 15.8123 13.4396 16.457V16.543C13.4396 17.1877 12.9011 17.7143 12.2418 17.7143H9C8.34066 17.7143 7.80219 18.2408 7.80219 18.8856V18.9716C7.80219 19.6163 8.34066 20.1429 9 20.1429H17.3077C17.967 20.1429 18.5055 20.6694 18.5055 21.3142V21.4001C18.5055 22.0449 17.967 22.5714 17.3077 22.5714H11.6264C10.967 22.5714 10.4286 23.098 10.4286 23.7427V23.8287C10.4286 24.4734 10.967 25 11.6264 25H17.7472C17.8461 25 17.9341 24.9893 18.022 24.9678C22.4945 24.6024 26 20.9488 26 16.4785C26.011 11.804 22.1099 8 17.2967 8ZM14.8681 16.543C14.8681 15.8875 15.4176 15.3502 16.0879 15.3502C16.7582 15.3502 17.3077 15.8875 17.3077 16.543C17.3077 17.1985 16.7582 17.7358 16.0879 17.7358C15.4066 17.725 14.8681 17.1985 14.8681 16.543Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2516_4956",
    x: 0,
    y: 3,
    width: 31,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2516_4956"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2516_4956",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMover);
export default __webpack_public_path__ + "static/media/mover.bebcd623952c1e2f1507b7d44c2d85dc.svg";
export { ForwardRef as ReactComponent };